import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";

function SecurityGuardServices(){

  const scrollToTop = () => {
    window.scrollTo(0, 0)
}

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "The Helper Ji security guard maintains entry records properly and stays alert during duty hours. Control has improved.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "After Helper Ji's security services were deployed, unnecessary visitors reduced noticeably. We are grateful.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "Night duty is taken seriously by HelperJi security staff. Guards stay at their post.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

    return(
        <Fragment>
          <Helmet>
            <title>
          Professional Security Guard Services | Trained Security Manpower Services
        </title>

        <meta
          name="description"
          content="Professional security guard services providing trained security guards, corporate security manpower & reliable security solutions for offices & commercial properties."
        />

        <meta
          name="keywords"
          content="Security Guard Services, Professional Security Guard Services, Trained Security Guards, Security Manpower Services, Corporate Security Services, Commercial Security Services, Professional Security Guards, Security Guard Manpower, Security Services Provider, Corporate Security Guard Services"
        />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="allow-search" content="yes" />
        <meta name="copyright" content="Helper Ji" />

        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href="https://www.helperji.in/security-guard-services"
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta
          property="og:title"
          content="Professional Security Guard Services | Trained Security Manpower Services"
        />
        <meta
          property="og:description"
          content="Professional security guard services providing trained security guards, corporate security manpower & reliable security solutions for offices & commercial properties."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/security1.jpeg"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.helperji.in/security-guard-services"
        />

        {/* ===== TWITTER META ===== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Professional Security Guard Services | Trained Security Manpower Services"
        />
        <meta
          name="twitter:description"
          content="Professional security guard services providing trained security guards, corporate security manpower & reliable security solutions for offices & commercial properties."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/security1.jpeg"
        />

        {/* ===== WEBPAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://www.helperji.in/security-guard-services",
            "name": "Professional Security Guard Services | Trained Security Manpower Services",
            "description": "Professional security guard services providing trained security guards, corporate security manpower & reliable security solutions for offices & commercial properties."
          }
          `}
        </script>

        {/* ===== PRODUCT SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "Security Guard Services",
            "image": "https://www.helperji.in/assets/img/security1.jpeg",
            "description": "Professional security guard services providing trained security guards, corporate security manpower & reliable security solutions for offices & commercial properties.",
            "brand": {
              "@type": "Brand",
              "name": "Helper Ji"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "ratingCount": "578"
            }
          }
          `}
        </script>

        {/* ===== BREADCRUMB SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.helperji.in"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Security Guard Services",
                "item": "https://www.helperji.in/security-guard-services"
              }
            ]
          }
          `}
        </script>
          <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
          </Helmet>
            
            <Floatingcall />
         
            <section id="about" class="about">
            <div class="container" data-aos="fade-up">

            <div class="section-header">
            <h2>Security Guard Services</h2>
            <p>Helper Ji's Premier Security Guard Services: Feel Safe and Confident </p>
             </div>

           <div class="row gy-4">
           <div class="col-lg-6">
            <img src="/assets/img/security1.jpeg" class="img-fluid rounded-4 mb-4" alt="" />
            
            </div>
          
          <div class="col-lg-6">
            <div class="content ps-0 ps-lg-5">
              <h3 class="fst-italic">
              With Helper Ji's Security Gaurd Services, we ensure your safety
              </h3>
              <p className="text-justify">
              Helper Ji takes pleasure in offering the best security guard services available in Noida, making sure your property is safe and secure. As one of the top security guard firms, we take great pride in our professional and thorough approach to protecting your assets, which demonstrates our devotion to security.
              </p>
              <p className="text-justify">Our well-trained security officers are prepared to manage a range of security requirements, such as keeping an eye on entrances, policing the area, and handling emergencies. Whether you require security for an event, residential complex, or business office, our staff guarantees all-encompassing protection by taking a proactive approach to safety.</p>
              <p className="text-justify">The security guards at Helper Ji are skilled in handling conflicts, responding to emergencies, and utilising contemporary security technologies in addition to receiving basic security training. Our guards keep a close eye on CCTV cameras, secure entryways, and make sure that all safety procedures are properly followed.</p>
              <p></p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section id="services" class="services sections-bg">
          <div class="container" data-aos="fade-up">
    
            <div class="row gy-4">
              
              <div class="col-lg-6">
                <div class="content ps-0 ps-lg-5">
                  <h2>
                  Why Choose Helperji's Private Security Services:
                  </h2>
                  <p className="text-justify">
                  Helper Ji is renowned for its professionalism and dedication to perfection, in addition to providing top-notch on-site security services. Because they get extensive training, our security staff members are well-equipped to properly manage and mitigate hazards.
                  </p>
                  <ul>
                    <li>constant surveillance of the property</li>
                    <li>Crisis intervention and emergency response</li>
                    <li>CCTV surveillance and monitoring</li>
                    <li>Controlling access and managing visitors</li>
                    <li>Services for event security</li>
                    <li>Security guard services for homes and businesses</li>
                    <li>Personalised security measures catered to your requirements</li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-6">
                <img src="/assets/img/security3.png" class="img-fluid rounded-4 mb-4" alt="" />
                
              </div>
            </div>
    
          </div>
        </section>

         <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

      <section id="services" class="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
            Security Guard Services – FAQs
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                What types of locations do you provide security guards for?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  We provide security guards for offices, residential societies, warehouses, construction sites, and commercial properties.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Are Helper Ji security guards trained before deployment?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, all guards are trained in basic security procedures, visitor handling, emergency response, and discipline before placement.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                 Can we hire security guards for night shifts only?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, guards can be deployed for day shifts, night shifts, or 24/7 duty based on your requirements.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Do security guards maintain visitor records?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, guards handle entry and exit registers and follow access control rules as instructed by the client.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Can guards be replaced if performance is not satisfactory?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                Yes, Helper Ji provides replacement support if the assigned guard does not meet expectations.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       <LandingPageClient />
        </Fragment>
    )
}

export default SecurityGuardServices;